import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo, useRef } from 'react';
import classnames from 'classnames/bind';
import GoogleMapReact from 'google-map-react';
import configment from '@adc/configment';
import styles from './styles.scss';
import Icon from '../../elementals/icon';
const cx = classnames.bind(styles);
const GOOGLE_MAPS_LIBRARIES = ['places'];
const US_CENTER_LAT_LNG = {
    lat: 39.8097343,
    lng: -98.5556199,
};
const DEFAULT_ZOOM_LEVEL = 18;
const defaultSettings = {
    center: US_CENTER_LAT_LNG,
    zoom: DEFAULT_ZOOM_LEVEL,
};
const SimpleMap = ({ defaultView, coords, createMapOptions = () => ({}), onMapClick = () => undefined, showStreetView = false, }) => {
    const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);
    const [streetViewAvailable, setStreetViewAvailable] = useState(true);
    const streetViewRef = useRef(null);
    const _createMapOptions = useMemo(() => {
        return (maps) => {
            return {
                mapTypeControlOptions: {
                    position: maps.ControlPosition.TOP_RIGHT,
                },
                mapTypeControl: true,
                fullscreenControl: false,
                streetViewControl: false,
                clickableIcons: false,
                zoomControl: false,
                gestureHandling: 'none',
                draggableCursor: 'pointer',
                ...createMapOptions(maps),
            };
        };
    }, [createMapOptions]);
    const onGoogleApiLoaded = ({ map, maps }) => {
        setGoogleMapsLoaded(true);
        if (!showStreetView)
            return;
        const streetView = new maps.StreetViewPanorama(document.getElementById('street-view'), {
            position: coords,
            pov: { heading: 270, pitch: 0 },
            zoom: 1,
            disableDefaultUI: true,
            clickToGo: false,
        });
        map.setStreetView(streetView);
        const sv = new maps.StreetViewService();
        sv.getPanorama({
            location: { lat: coords?.lat, lng: coords?.lng },
            radius: 50,
        }, (_, status) => {
            setStreetViewAvailable(status === maps.StreetViewStatus.OK);
        });
    };
    if (showStreetView && !streetViewAvailable && defaultView)
        return defaultView;
    return (_jsxs("div", { className: cx('map-container'), children: [_jsx(GoogleMapReact, { bootstrapURLKeys: {
                    client: configment.get('GOOGLE_MAP_CLIENT_ID', ''),
                    language: 'en',
                    version: 'weekly',
                    libraries: GOOGLE_MAPS_LIBRARIES,
                }, center: coords ? { ...coords } : defaultSettings.center, defaultZoom: defaultSettings.zoom, options: _createMapOptions, yesIWantToUseGoogleMapApiInternals: true, onGoogleApiLoaded: onGoogleApiLoaded, onClick: onMapClick, children: googleMapsLoaded && coords && (_jsx(Marker, { onClick: onMapClick, ...coords })) }), showStreetView && (_jsx("div", { id: 'street-view', onClick: e => {
                    const target = e.target;
                    if (target.closest('.gm-control-active')) {
                        e.stopPropagation();
                    }
                    else {
                        onMapClick(e);
                    }
                }, ref: streetViewRef, className: cx('street-view', 'pointer') }))] }));
};
const Marker = (_props) => {
    const { onClick } = _props;
    return (_jsx("div", { onClick: onClick, className: cx('marker-container'), children: _jsx(Icon, { name: 'fa-location-dot', iconStyle: 'solid', size: 'huge', color: 'error', className: cx('marker') }) }));
};
export default SimpleMap;
//# sourceMappingURL=index.js.map